import React, { useContext } from "react";
import { AppContext } from "../../context";

function ExtraList({ extraList }) {
  const info = useContext(AppContext);

  extraList.sort((a, b) =>
    a.name?.[info.language || "pt"] > b.name?.[info.language || "pt"] ? 1 : -1
  );

  return (
    extraList?.length > 0 && (
      <div style={{ marginTop: 10, marginLeft: 30 }}>
        <div>
          <strong>{info.t("includedExtras")}</strong>
        </div>
        {extraList?.map((extra, index) => (
          <div key={index}>{extra.name[info.language || "pt"]}</div>
        ))}
        <strong>
          {info.t("total")}: {extraList?.reduce((a, c) => a + c.price, 0)} €
        </strong>
      </div>
    )
  );
}

export default ExtraList;
